/**
 * Type definitions for user activity data.
 *
 * @description Shared types for account activity tracking and statistics.
 */

export type WebsiteActionType =
  | "CREATE"
  | "UPDATE"
  | "DELETE"
  | "RESTORE"
  | "SUGGEST";

export type ActivityTimePeriod = "ALL" | "WEEK" | "MONTH" | "YEAR";

export const WEBSITE_ACTION_TYPES: WebsiteActionType[] = [
  "CREATE",
  "UPDATE",
  "DELETE",
  "RESTORE",
  "SUGGEST",
];

export const ACTIVITY_TIME_PERIODS: ActivityTimePeriod[] = [
  "ALL",
  "WEEK",
  "MONTH",
  "YEAR",
];

export interface AccountActivity {
  id: string;
  action: WebsiteActionType;
  title: string;
  occurredAt: string;
  userName?: string | null;
}

export interface AccountStatisticsDto {
  memberSince: string;
  activityCount: number;
  actionCounts?: Partial<Record<WebsiteActionType, number>>;
}

export interface AccountStatistics {
  memberSince: string;
  activityCount: number;
  actionCounts: Record<WebsiteActionType, number>;
}

export const DEFAULT_ACTION_COUNTS: Record<WebsiteActionType, number> = {
  CREATE: 0,
  UPDATE: 0,
  DELETE: 0,
  RESTORE: 0,
  SUGGEST: 0,
};
